import {withStyle} from 'baseui'
import {StyledSpinnerNext} from 'baseui/spinner'

const LoadingSpinner = withStyle(StyledSpinnerNext, ({$theme}) => ({
  borderTopColor: $theme.colors.primary,
}))

export default LoadingSpinner
